import { ReceiverType } from '../../push/envelope'

export interface INotification {
  id:            string //  "db658c93-e9fb-497e-8acc-ce4fecd3a9ea"
  text:          string
  // Optional metadata derived from the typed push envelope (DCCD-2371).
  event?:        string
  group?:        string
  severity?:     string
  receiverType?: ReceiverType
  hash?:         string
  actionUrl?:    string
  params?:       Record<string, string>
  // True when text should be rendered client-side from event + params (so the
  // toast can re-localize on language change). False/undefined -> show `text`.
  localizable?:  boolean
}

export class Notification {
  id:            string
  text:          string
  event?:        string
  group?:        string
  severity?:     string
  receiverType?: ReceiverType
  hash?:         string
  actionUrl?:    string
  params?:       Record<string, string>
  localizable?:  boolean

  constructor(notification: INotification) {
    this.id           = notification.id
    this.text         = notification.text
    this.event        = notification.event
    this.group        = notification.group
    this.severity     = notification.severity
    this.receiverType = notification.receiverType
    this.hash         = notification.hash
    this.actionUrl    = notification.actionUrl
    this.params       = notification.params
    this.localizable  = notification.localizable
  }
}

export default Notification
